<template src="./Searchfield.html"></template>

<script>

export default {
  name: 'Searchfield',
  props: ['count'],
  data () {
    return {
      searchword: ''
    }
  },
  computed: {
    sort: function() {
      return this.$parent.sort
    }
  },
  watch: {
    searchword: function () {
      this.$parent.searchword = this.searchword
      this.$parent.reduceList(this.searchword)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Searchfield.vue?359d7bb7